import { render, staticRenderFns } from "./confirm-businnes-details.vue?vue&type=template&id=1c91d65f&scoped=true"
import script from "./confirm-businnes-details.vue?vue&type=script&lang=js"
export * from "./confirm-businnes-details.vue?vue&type=script&lang=js"
import style0 from "./confirm-businnes-details.vue?vue&type=style&index=0&id=1c91d65f&prod&lang=css"
import style1 from "./confirm-businnes-details.vue?vue&type=style&index=1&id=1c91d65f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c91d65f",
  null
  
)

export default component.exports